import { MapPin, Navigation } from "lucide-react";
import { Reveal, SectionHeading, GhostButton, GoldButton } from "./shared";
import { ADDRESS, MAPS_DIR_URL, MAPS_EMBED_URL, BOOKING_URL } from "./content";

export default function MapSection() {
    return (
        <section id="visit" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <SectionHeading
                    eyebrow="Find Us"
                    title="The studio in Wickford"
                    sub="Unit 6 Hodgson Court, Hodgson Way. Just follow the fairy lights."
                />
                <div className="mt-14 grid gap-8 lg:grid-cols-12">
                    <Reveal className="lg:col-span-7">
                        <div
                            className="overflow-hidden rounded-3xl border border-gold/25 shadow-[0_24px_70px_rgba(0,0,0,0.5)]"
                            data-testid="location-map-container"
                        >
                            <iframe
                                title="Map to Essex Photography Studio, Unit 6 Hodgson Court, Wickford SS11 8XR"
                                src={MAPS_EMBED_URL}
                                loading="lazy"
                                className="map-theme h-[380px] w-full border-0 sm:h-[440px]"
                                allowFullScreen
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.12} className="lg:col-span-5">
                        <div className="glass-card flex h-full flex-col justify-between rounded-3xl p-8" data-testid="visit-card">
                            <div>
                                <MapPin className="h-8 w-8 text-crimson" strokeWidth={1.6} />
                                <h3 className="mt-5 font-serif text-2xl font-bold text-cream">Essex Photography Studio</h3>
                                <address className="mt-3 not-italic leading-relaxed text-mist" data-testid="studio-address">
                                    {ADDRESS.line1}
                                    <br />
                                    {ADDRESS.line2}
                                </address>
                            </div>
                            <div className="mt-8 flex flex-col gap-4">
                                <GhostButton href={MAPS_DIR_URL} target="_blank" rel="noopener noreferrer" testId="directions-button">
                                    <Navigation className="h-4 w-4" />
                                    Get directions
                                </GhostButton>
                                <GoldButton href={BOOKING_URL} testId="visit-cta-button">
                                    Book your £49 session
                                </GoldButton>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
